import { ZIndex } from '@celito.clients/theme';
import { makeStyles, shorthands } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';
import { ThemeFontFamily } from 'libs/theme/src/lib/theme-fontfamily';

export const actionColumnListViewStyles = makeStyles({
  btnTriiger: {
    ...shorthands.padding('6px'),
    display: 'flex',
    justifyContent: 'center',
    width: '38px',

    ':hover': {
      backgroundColor: Color.gray_1300,
    },
  },

  actionMenuItem: {
    '&:hover > span > div': {
      fontFamily: ThemeFontFamily.bold,
    },
    ...shorthands.padding('14px', '8px'),
  },

  menuPopover: {
    zIndex: ZIndex.Dropdown,
  },

  menuList: {
    '> div:hover': {
      backgroundColor: 'rgba(37, 72, 247, 0.05)',
    },
  },

  itemContent: {
    display: 'flex',
    ...shorthands.gap('8px'),
    alignItems: 'center',
    minWidth: '160px',
  },

  spinner: {
    marginTop: '0.375rem',
    marginBottom: '0.375rem',
    marginLeft: '0.4rem',
  },

  viewMenuItem: {
    '&:hover': {
      fontFamily: ThemeFontFamily.bold,
    },
  },
});
